module.exports = __webpack_public_path__ + "static/media/unicred-porto-alegre-edital.54eb76b6.png";